var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxMen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ae1545fd-6e0c-43e9-b34d-19a2ebcd28b1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "be8d6c3f-06a4-4f51-b645-12b2b5bb9d21",
    "data-name": "Path 88",
    d: "M16.983,3.91V3.748a.1.1,0,0,0-.006-.041c-.006-.014,0-.023,0-.034h0a.183.183,0,0,0-.009-.039.358.358,0,0,0-.009-.035V3.593c0-.011-.008-.021-.011-.032a.23.23,0,0,0-.022-.046h0l-.007-.022v-.01a.378.378,0,0,0-.017-.035.247.247,0,0,0-.03-.042c-.009-.009-.01-.018-.016-.026s-.03-.039-.041-.057L16.8,3.315A.826.826,0,0,0,16.69,3.2h0l-.023-.017-.04-.029h0l-.03-.018-.037-.021h0l-.039-.02-.033-.016h0l-.031-.014-.04-.014h0l-.033-.009-.046-.011h-.028l-.051-.016h-.173l-4.495.429a.815.815,0,0,0,.076,1.627h.078L14,4.858l-2.407,2.4a5.384,5.384,0,1,0,.62,8.146h0a5.385,5.385,0,0,0,.533-6.992l2.406-2.406-.213,2.255a.815.815,0,0,0,.735.888h.077a.814.814,0,0,0,.811-.739l.424-4.5v0ZM11.055,14.254h0a3.753,3.753,0,1,1,0-5.308h0a3.752,3.752,0,0,1,0,5.307",
    style: {
      fill: "#005a7d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxMen);
export default __webpack_public_path__ + "static/media/bxMen.25a08115e7c7ce6080bb7aeb30a6daec.svg";
export { ForwardRef as ReactComponent };